import { motion } from "framer-motion";
import {
  CheckCircle,
} from "lucide-react";

const list = [
  "Interactive AI Learning",
  "Real-time Analytics",
  "Certification Management",
  "Custom Learning Paths",
];

export default function PlatformPreview() {
  return (
    <section className="bg-slate-900 py-28">

      <div className="container mx-auto px-6">

        <div className="grid lg:grid-cols-2 gap-20 items-center">

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >

            <p className="text-cyan-400 font-semibold uppercase">
              Platform
            </p>

            <h2 className="text-5xl font-bold text-white mt-3">
              Everything You Need In One Dashboard
            </h2>

            <p className="text-slate-400 mt-6 leading-8">
              A modern learning ecosystem combining AI,
              analytics, assessments and certifications into
              one intuitive platform.
            </p>

            <div className="mt-10 space-y-5">

              {list.map((item) => (

                <div
                  key={item}
                  className="flex items-center gap-4"
                >
                  <CheckCircle className="text-cyan-400" />

                  <span className="text-slate-300">
                    {item}
                  </span>

                </div>

              ))}

            </div>

          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: .9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >

            <div className="rounded-3xl border border-white/10 bg-slate-950 p-6">

              <img
                src="/dashboard.png"
                alt=""
                className="rounded-2xl"
              />

            </div>

          </motion.div>

        </div>

      </div>

    </section>
  );
}